import { createProjectByCategory, ProjectCategory, projectStore } from "@droid/project-v2-interface"
import { actionScriptUtils } from "@droid/project-v2-ext"
import { Log } from "@fanfanlo"
import { Button } from "@mui/material"
import { useRouter } from "next/router"
import { useState } from "react"
import { useTranslation } from "react-i18next"
import { ProjectCategorySelectDialog } from "./ProjectCategorySelectDialog"
const fileLog = new Log(true, 'CreateProjectButton');
fileLog.pause = true;
fileLog.childrenPaused = true;

export const CreateProjectButton = () => {
    const { t } = useTranslation("droid-project-v2-ui/ui/components/content")
    const router = useRouter()
    const [dialogOpen, setDialogOpen] = useState(false)

    fileLog.log(`[CreateProjectButton] 渲染, dialogOpen=${dialogOpen}`)

    const handleOpenDialog = () => {
        fileLog.log(`[CreateProjectButton] 打开类别选择对话框`)
        setDialogOpen(true)
    }

    const handleCloseDialog = () => {
        fileLog.log(`[CreateProjectButton] 关闭类别选择对话框`)
        setDialogOpen(false)
    }

    const handleSelectCategory = async (category: ProjectCategory) => {
        fileLog.log(`[CreateProjectButton] 用户选择类别: ${category}`)

        const project = createProjectByCategory(category)
        fileLog.log(`[CreateProjectButton] 创建 project, ulid=${project.ulid}, category=${project.category}`)

        // 如果是 ScriptRunner，添加一个 script action
        if (category === ProjectCategory.ScriptRunner) {
            fileLog.log(`[CreateProjectButton] ScriptRunner: 添加 script action`)
            const triggerActionGroup = project.children?.[0]
            if (!triggerActionGroup) {
                fileLog.error(`[CreateProjectButton] triggerActionGroup is undefined`)
                return
            }
            fileLog.log(`[CreateProjectButton] triggerActionGroup.ulid=${triggerActionGroup.ulid}`)

            const triggerAction = triggerActionGroup.children?.[0]
            if (!triggerAction) {
                fileLog.error(`[CreateProjectButton] triggerAction is undefined`)
            } else {
                const actionGroup = triggerAction.actionGroup
                if (actionGroup) {
                    const scriptAction = actionScriptUtils.createDefaultData()
                    fileLog.log(`[CreateProjectButton] 创建 scriptAction:`, JSON.stringify(scriptAction))
                    // 修改：只维护children（存储完整对象），list由后端维护
                    if (!actionGroup.children) {
                        actionGroup.children = []
                    }
                    actionGroup.children.push(scriptAction)
                    fileLog.log(`[CreateProjectButton] actionGroup.children.length after: ${actionGroup.children.length}`)
                }
            }
        }

        projectStore.addDraft(project)
        fileLog.log(`[CreateProjectButton] project 已添加到 draft store`)

        // 构建跳转路径
        let path = `/project-editor?ulid=${project.ulid}`

        // 如果是 QuickAction，添加 isNew 参数，用于在编辑器中判断是否需要跳转到 action-list
        if (category === ProjectCategory.QuickAction) {
            path += '&isNew=true'
            fileLog.log(`[CreateProjectButton] QuickAction: 添加 isNew 参数`)
        }

        fileLog.log(`[CreateProjectButton] 准备跳转到: ${path}`)

        await router.prefetch(path)
        router.push(path)

        setDialogOpen(false)
    }

    return (
        <span>
            <Button
                data-id={"create-project-button.b79975b3-cc10-4e3e-bc05-478a98c925b6"}
                data-typeof-create-project-id="create-project-btn-from-ui-components-create-project-button"
                id="typeof-create-project-id-create-project-btn-from-ui-components-create-project-button"
                data-testid="CreateProjectButton__button__01JFXYZ7K8M2N3P4Q5R6S7T8"
                data-test-comment="创建项目按钮，点击后打开项目类别选择对话框"
                onClick={handleOpenDialog}
            >
                {t("content.create")}
            </Button>

            <ProjectCategorySelectDialog
                open={dialogOpen}
                onClose={handleCloseDialog}
                onSelect={handleSelectCategory}
            />
        </span>
    )
}
